










import {
  Component,
} from 'vue-property-decorator';

import AddToCartButton from '@/components/AddToCartButton.vue';
import BuyboxFeatureComponent from './BuyboxFeatureComponent';

@Component({
  components: {
    AddToCartButton,
  },
  props: {
    quantity: {
      type: Number,
      required: true,
    },
  },
})
export default class AddToCartFeature extends BuyboxFeatureComponent { }

